import React from 'react';

/**
 * The page container.
 *
 * `variant` sets the max-width and gutters at ≥1024 (see
 * `wordrush-desktop.css`). Below that it is exactly `.app-shell` +
 * `.screen-pad` — i.e. the phone layout, byte for byte.
 *
 *   narrow   480px   auth, one-decision screens
 *   content  720px   the default — lobby, daily, settings
 *   wide    1080px   the dashboard template
 *   stage   1280px   a screen whose child is a StageLayout
 *
 * This exists to kill the per-screen wrapper div. A screen should never
 * reach for `max-width` itself; if it wants a different measure, it wants
 * a different variant.
 */
export type PageVariant = 'narrow' | 'content' | 'wide' | 'stage' | 'max';

export interface PageProps {
  variant?: PageVariant;
  children: React.ReactNode;
  /** Extra classes on the scroll container. */
  className?: string;
  /** Extra classes on the outer `.app-shell`. */
  shellClassName?: string;
  style?: React.CSSProperties;
}

export function Page({
  variant = 'content',
  children,
  className = '',
  shellClassName = '',
  style,
}: PageProps) {
  return (
    <div className={`app-shell ${shellClassName}`.trim()}>
      <div className={`screen-pad wr-page wr-page--${variant} ${className}`.trim()} style={style}>
        {children}
      </div>
    </div>
  );
}
